import type { DemoLinkAccessPolicyType } from '@carboncopyco/types';
import { Dropdown, DropdownItem, TextCaption } from '@carboncopyco/ui';
import { DemoLinkAccessPolicyItem } from './DemoLinkAccessPolicyItem';
import { useDemoLinkAccessPolicy } from './DemoLinkModalContext';
import { demoLinkAccessPolicyTypes } from './consts';

export function DemoLinkAccessPolicyItems({
  disabled,
  allowed,
}: {
  disabled?: boolean;
  allowed?: boolean;
}) {
  const [accessPolicy, setDemoLinkAccessPolicy] = useDemoLinkAccessPolicy();
  if (disabled) {
    return (
      <DemoLinkAccessPolicyItem
        isSelected={false}
        variant="option"
        accessPolicy={accessPolicy}
      />
    );
  }

  if (!allowed) {
    return (
      <DemoLinkAccessPolicyItem
        disabled
        variant="trigger"
        accessPolicy={accessPolicy}
      />
    );
  }

  return (
    <Dropdown
      width="100%"
      triggerElement={
        <DemoLinkAccessPolicyItem
          variant="trigger"
          accessPolicy={accessPolicy}
        />
      }
    >
      <div
        role="group"
        className="w-[554px] p-5"
      >
        {[
          ...(Object.keys(
            demoLinkAccessPolicyTypes
          ) as DemoLinkAccessPolicyType[]),
        ].map((accPol) => (
          <DropdownItem
            key={accPol}
            onClick={() => setDemoLinkAccessPolicy(accPol)}
          >
            <DemoLinkAccessPolicyItem
              isSelected={accPol === accessPolicy}
              accessPolicy={accPol}
            />
          </DropdownItem>
        ))}
      </div>
    </Dropdown>
  );
}

export function DemoLinkAccessPolicySelect(props: {
  disabled?: boolean;
  allowed?: boolean;
}) {
  return (
    <div className="flex flex-col">
      <div className="mb-4">
        <TextCaption
          label="General access"
          color="text-ds-natural-600"
        />
      </div>
      <DemoLinkAccessPolicyItems {...props} />
    </div>
  );
}
